import * as React from "react";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import ListForm from "./ListForm";
import errorHandler from "../../../../../hoc/ErrorHandler";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import context from "../../../../../context/auth-context";
import Spinner from "../../../../UI/Spinner/Spinner";
import { useStore } from "./store";
import { useAlert } from "react-alert";

const decode = (input) => {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

const FORM_VALIDATION = Yup.object().shape({
  title: Yup.string().required("Add a title"),
  venue: Yup.string().required("Add a venue for the meeting"),
  startDate: Yup.string().required("Select a start date").nullable(),
  endDate: Yup.string().required("Select a end time").nullable(),
  group: Yup.number().required("Select a group").nullable(),
  invitees: Yup.array().transform(v => (v === null ? [] : v)).min(1, 'Add atleast one invitee'),
  meetingPack: Yup.number().required("Select a meeting pack").nullable(),
  type: Yup.string().required('Select a meeting type')
})

export const fetchMeetingPacks = (id) => axios.get(`/groups/${id}/folders`);

function EditEvent({ editEvent, event, formRef, setOpenModal, setMeeting, meeting, isLocked }) {
  const updatedTitle = React.useMemo(() => editEvent.title, [editEvent.title])
  const startDate = React.useMemo(() => editEvent.start, [editEvent.start])
  const endDate = React.useMemo(() => editEvent.end, [editEvent.end])
  const groups = useSelector(state => state.groups.companyGroups.data)
  const users = useSelector(state => state.groups.companyUsers)
  const [meetingPacks, setMeetingPacks] = React.useState(null);
  const authContext = React.useContext(context);
  const [groupUsers, setGroupUsers] = React.useState(null)
  const dispatch = useDispatch();
  const { companyId } = authContext
  const getValues = useStore(state => state.values);
  const reset = useStore(state => state.reset);
  const alert = useAlert();

  const getEventDetails = async (id) => {
    return await axios.get(`/utilities/company-events/meeting/${id}`);
  };

  const updateEventDetails = (id, body) => {
    return axios.post(`/utilities/company-events/meeting/${id}`, body);
  };

  React.useEffect(() => {
    if (meeting && meeting.group) {
      fetchMeetingPacks(meeting.group.id_group).then(response => {
        if (response.data && Array.isArray(response.data)) {
          setMeetingPacks([...response.data])
        }
      })
    }
  }, [meeting])

  React.useEffect(() => {
    reset()
  }, [editEvent.id, reset])

  React.useEffect(() => {
    if (Array.isArray(groups) && Array.isArray(users)) {
      const obj = {}
      groups.forEach(x => {
        obj[x.id] = []
      })
      users.forEach(x => {
        if (Array.isArray(x.groups) && x.active === "Y") {
          const userObj = {
            id: x.id,
            name: x.name
          }
          x.groups.forEach(y => {
            obj[y.id] = Array.isArray(obj[y.id]) ? [...obj[y.id], userObj] : [userObj]
          })
        }
      })
      setGroupUsers({ ...obj })
    }
  }, [users, groups, getValues.group])

  React.useEffect(() => {
    if (getValues && meeting && getValues.group) {
      fetchMeetingPacks(getValues.group).then(response => {
        if (response.data && Array.isArray(response.data)) {
          setMeetingPacks([...response.data])
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues, meeting])


  React.useEffect(() => {
    if (editEvent.event_id) {
      getEventDetails(editEvent.event_id)
        .then((res) => {
          if (res.data.data) {
            setMeeting(res.data.data);
          }
        }).catch((err) => {
          alert.show('An Error has ocuured, reopen the dialog box', { type: 'error' });
        })
    }
    return () => {
      setMeeting(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEvent.event_id])

  React.useEffect(() => {
    if ((!groups || !users) && companyId) {
      const getCompanyGroups = async () => {
        return await axios.get(`/companies/${companyId}/groups`);
      };
      axios.get("/users")
        .then((res) => {
          dispatch({ type: "INSTANTIATE_USERS", payload: res.data })
        }).catch(() => {
          if (!navigator.onLine)
            alert.show('Check your internet connection', { type: 'error' });
        })
      getCompanyGroups().then(groups => {
        const decodeGroupArray = Array.isArray(groups.data) ? groups.data?.map(group => {
          const decodeName = decode(group.name);
          return { ...group, name: decodeName }
        }) : []
        dispatch({ type: 'INSTANTIATE_GROUPS', payload: decodeGroupArray })
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
      ).catch(() => console.log(''))
    }

  }, [groups, companyId, dispatch, alert, users])
  return (
    groups && meeting && meeting.group && groupUsers && Array.isArray(meetingPacks) ? (
      <Formik
        initialValues={{
          title: updatedTitle,
          startDate: startDate,
          endDate: endDate,
          group: meeting.group ? meeting.group.id_group ? getValues.group && getValues.group !== meeting.group.id_group ? getValues.group : meeting.group.id_group : '' : '',
          invitees:
            meeting.group &&
              Array.isArray(meeting.invitees) ?
              [...new Set(meeting.invitees?.map(x => x.id))]
              : [],
          type: meeting.tag ? meeting.tag.toString() : '',
          venue: meeting && meeting.room,
          meetingPack: meeting.meeting_pack
        }}
        innerRef={formRef}
        validationSchema={FORM_VALIDATION}
        enableReinitialize
        onSubmit={values => {
          switch (meeting.status) {
            case 2:
              alert.show('This Meeting is in progress, it cannot be edited', { type: 'error' });
              break;
            case 3:
              alert.show('This Meeting is completed, it cannot be edited', { type: 'error' });
              break;
            case 5:
              alert.show('This Meeting is canceled, it cannot be edited', { type: 'error' });
              break;
            default:
              break;
          }

          updateEventDetails(editEvent.event_id, values)
            .then((res) => {
              event.current.setDates(values.startDate, values.endDate)
              event.current.setProp('title', values.title);
              setOpenModal(false);
              if (res && res.data)
                alert.show('Event Updated', { type: "success" })
            })
            .catch(() => console.log("ERROR"))
        }}
      >
        {({ initialValues, setFieldValue, values, errors, setFieldTouched }) => (
          <Form>
            <ListForm
              errors={errors}
              isLocked={isLocked}
              setFieldTouched={setFieldTouched}
              initialValues={initialValues}
              values={values}
              initialStartDate={startDate}
              initialEndDate={endDate}
              groups={groups}
              groupUsers={groupUsers}
              isSubmitting
              setFieldValue={setFieldValue}
              meeting
            />
          </Form>
        )}
      </Formik>
    ) : <Spinner />
  )
}


export default errorHandler(EditEvent, axios);